<page-meta
  description="BitOasis is MENA's leading platform that allows you to securely buy, sell and trade crypto assets like Bitcoin, Ether, XRP and Bitcoin Cash at the best rates. Currently available in UAE, KSA, Bahrain, Kuwait, Oman, Jordan and Morocco"
  keywords="Blockchain, Bitcoin UAE, Crypto Dubai, Cryptocurrency Exchange, Buy Bitcoin, Ethereum price, XRP, BTC price, ETH, Binance, eToro, Rain.bh"
  i18n-description="@@pageMeta.description.general"
  i18n-keywords="@@pageMeta.keywords.general"
  [isDefault]="true"
>
</page-meta>
<kyc-additional-details-alert></kyc-additional-details-alert>
<router-outlet></router-outlet>
<app-toaster></app-toaster>
<captcha-component></captcha-component>
